.cronScheduler {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  font-size: 14px;
}

.label {
  color: #595959;
  white-space: nowrap;
  font-size: 13px;
}

.select {
  appearance: none;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23595959'/%3E%3C/svg%3E") no-repeat right 8px center;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 4px 28px 4px 12px;
  font-size: 14px;
  line-height: 1.5;
  color: #262626;
  cursor: pointer;
  outline: none;
  min-width: 60px;
  transition: border-color 0.2s;

  &:hover {
    border-color: #40a9ff;
  }

  &:focus {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
}

.multiSelect {
  min-width: 140px;
}

.multiSelectTrigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 4px 8px 4px 12px;
  font-size: 14px;
  line-height: 1.5;
  color: #262626;
  cursor: pointer;
  background: #fff;
  transition: border-color 0.2s;
  min-height: 32px;

  &:hover,
  &.open {
    border-color: #40a9ff;
  }

  .placeholder {
    color: #bfbfbf;
  }

  .arrow {
    font-size: 10px;
    color: #595959;
    flex-shrink: 0;
  }
}

.multiSelectDropdown {
  z-index: 999999;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08);
  padding: 4px 0;
  max-height: 256px;
  overflow-y: auto;
  min-width: 100%;
}

.multiSelectOption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 12px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.15s;

  &:hover {
    background: #f5f5f5;
  }

  input[type="checkbox"] {
    accent-color: #1890ff;
    cursor: pointer;
  }
}
